import { Injectable } from '@angular/core';
import { ECaseStatus, ECaseStatusRequest, EServicePlaceRequest, ETypeOfDuration } from 'app/modules/api';
import { BehaviorSubject } from 'rxjs';

export interface CaseState {
  caseList: any[];
  currentIndex: number;
  page: number;
  limit: number;
  selectedStatus: ECaseStatusRequest | ECaseStatus;
  servicePlace: EServicePlaceRequest;
  selectedShop: number;
  selectedTime: ETypeOfDuration;
  orderBy: string;
  searchBox: string;
  isDesc: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CaseStateService {
  private caseStateSubject = new BehaviorSubject<CaseState>({
    caseList: [],
    currentIndex: 0,
    page: 1,
    limit: 10,
    selectedStatus: ECaseStatusRequest.All,
    servicePlace: EServicePlaceRequest.AllServicePlace,
    selectedShop: -1,
    selectedTime: ETypeOfDuration.AllTime,
    orderBy: 'caseId',
    searchBox: '',
    isDesc: true
  });
  

  caseState$ = this.caseStateSubject.asObservable();

  private countUpdateSubject = new BehaviorSubject<{ status: string; count: number }>(null);
  countUpdate$ = this.countUpdateSubject.asObservable();

  private refreshCountSubject = new BehaviorSubject<boolean>(false);
  refreshCount$ = this.refreshCountSubject.asObservable();

  // Set state
  setCaseState(state: CaseState) {
    this.caseStateSubject.next(state);
  }

  // Get current value
  getCaseState(): CaseState {
    return this.caseStateSubject.getValue();
  }

  updateStatusCount(status: string, count: number) {
    this.countUpdateSubject.next({ status, count });
  }

  triggerRefreshCount() {
    this.refreshCountSubject.next(true);
  }
}
